var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Calendar from 'react-calendar';
import { ListItemInput } from '@bootstraplabs/bsw-common-react';
var isMobile = navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/Android/i);
export default function CalendarInput(props) {
    if (isMobile) {
        return (_jsx(ListItemInput, { type: "date", labelWidth: props.labelWidth, label: props.label, value: props.date, onChange: props.onChange }, void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ onClick: function () { return props.showCalendar(true); } }, { children: _jsx(ListItemInput, { type: "date", label: props.label || 'TODO', labelWidth: props.labelWidth, value: props.date, disabled: true }, void 0) }), void 0),
            props.isCalendarOpen && (_jsx(Calendar, { "data-test": props.id, value: new Date(props.date), calendarType: "US", onChange: function (date) {
                    if (date instanceof Date) {
                        props.onChange(date.toISOString());
                        props.showCalendar(false);
                    }
                } }, void 0))] }, void 0));
}
//# sourceMappingURL=CalendarInput.js.map